import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/icons/bg_big_purple.svg'
import _imports_1 from '../assets/icons/bg_small_gray.svg'
import _imports_2 from '../assets/img/img_lady_compressed.png'


const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "absolute top-100px left-0 <sm:left-50px <xsm:left-0 transform translate-x-[calc(50vw-100%)]" }
const _hoisted_3 = { class: "horiz-center max-w-1440px mx-auto pb-50px pr-165px <xl:pr-40px <sm:pr-15px relative" }
const _hoisted_4 = { class: "w-1/2 <sm:w-180px" }
const _hoisted_5 = { class: "text-35px <lg:text-20px <lg:leading-22px <xl:text-26px <xl:leading-40px font-500 <sm:hidden uppercase leading-50px mt-110px <xl:mt-75px" }
const _hoisted_6 = { class: "pl-97px mt-77px <xl:mt-35px <sm:mt-77px pb-100px <xl:pb-0 <sm:pb-160px <xl:pl-0px" }
const _hoisted_7 = { class: "mt-60px <xl:ml-4px <xl:mt-22px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_parallax_div = _resolveComponent("parallax-div")!
  const _component_flying_span = _resolveComponent("flying-span")!
  const _component_the_top_fake_input = _resolveComponent("the-top-fake-input")!
  const _component_accent_button = _resolveComponent("accent-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_parallax_div, { class: "" }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              "data-depth": "0.1",
              class: "z-0 bg-slide1",
              src: _imports_0
            }, null, -1),
            _createElementVNode("img", {
              "data-depth": "0.1",
              class: "z-1 mt-100px ml-50px bg-slide2",
              src: _imports_1
            }, null, -1)
          ])),
          _: 1
        })
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "absolute h-760px z-2 max-h-[calc(100%-50px)] w-50vw h-50vw <sm:w-75vw <sm:h-75vw left-0 pointer-events-none -bottom-50px object-contain" }, [
        _createElementVNode("img", {
          class: "w-full max-h-full object-contain object-left",
          src: _imports_2
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "spacer" }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_flying_span, { timeout: 0 }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("E-RKO — партнёрский сервис"),
                _createElementVNode("br", null, null, -1),
                _createTextVNode(" для привлечения клиентов в банки")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_the_top_fake_input),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_router_link, { to: "/application" }, {
                default: _withCtx(() => [
                  _createVNode(_component_accent_button, { class: "<lg:text-14px" }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("Создать аккаунт")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _cache[3] || (_cache[3] = _createElementVNode("br", { class: "sm:hidden" }, null, -1)),
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-22px <lg:text-14px <sm:text-12px" }, " займет не более 15 минут", -1))
            ])
          ])
        ])
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "bg-hex-323232 relative z-4 h-140px <lg:h-100px <sm:h-50px transform translate-y-1px",
        style: {"clip-path":"polygon(0% 100%, 100% 100%, 100% 0%, 0% 100%)"}
      }, null, -1))
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "bg-hex-323232 relative z-4 h-30px" }, null, -1))
  ], 64))
}